/** Shared Recharts tooltip surface so every dashboard chart matches the app's
 * popover styling — one definition instead of a per-chart copy. */
export const CHART_TOOLTIP_CONTENT_STYLE = {
  background: "var(--color-popover)",
  border: "1px solid var(--color-border)",
  borderRadius: 6,
  color: "var(--color-popover-foreground)",
  fontSize: 12,
} as const
